import { faViber } from '@fortawesome/free-brands-svg-icons'
import {
  faNoteSticky,
  faCalendar,
  faSearch,
  faLeftRight,
  faChartLine,
  faReceipt,
  faLock,
  faGear,
  faHeart,
  faPoll,
  faBucket,
  faHistory,
  faLink
} from '@fortawesome/free-solid-svg-icons'

const initMenu = [


  {
    label: 'Create',
    path: '/#create',
    icon: faReceipt,
    submenu: [
      {
        label: 'Create Vibe',
        path: '/create-vibe',
        icon: faNoteSticky
      },
      {
        label: 'Create Poll',
        path: '/create-poll',
        icon: faChartLine
      }
    ]
  },
  {
    label: 'settings',
    path: '/settings',
    icon: faGear
  },
  {
    label: 'favorites',
    path: '/favorite',
    icon: faHeart
  },
  {
    label: 'My Vibes',
    path: '/my-vibes',
    icon: faViber
  },
  {
    label: 'My Polls',
    path: '/polls-list',
    icon: faPoll
  },
  {
    label: 'Calendar',
    path: '/calendar',
    icon: faCalendar
  },
  {
    label: 'Vibe Bucks',
    path: '/vibes-bucks',
    icon: faHistory  
  },
  {
    label: 'Links',
    path: '/my-links',
    icon: faLink
  },
  // {
  //   label: 'Privacy Policy',
  //   path: '/privacy-policy',
  //   icon: faGear
  // },
  // {
  //   label: 'Terms & Conditions',
  //   path: '/terms&condition',
  //   icon: faGear
  // }
]

export default initMenu
